/**
 * The one pill call-to-action an app-launch header carries on the right.
 *
 * Derived from site settings so a template can change it without a deploy.
 * Today it reads nothing: the Nightfall template's `app_launch` setting
 * (pre-launch waitlist ↔ live store badges) fills it in the next phase.
 * Returning null renders no CTA, which is the right default for every
 * existing tenant that picks the floating-glass header.
 */
export interface HeaderCta {
  label: string;
  href: string;
}

export function useHeaderCta(): HeaderCta | null {
  return null;
}
